import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, model, OnInit } from '@angular/core';
import { JobCardDetails } from '../../../../core/services/manage-complaints.service';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthContext } from '../../../../auth/services/auth.context';

interface DialogData {
  jobCardData: JobCardDetails;
  event: JobCardDetails;
  title: string;
  status: string;
}
@Component({
  selector: 'app-update-complaint-status-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './update-complaint-status-dialog.component.html',
  styleUrl: './update-complaint-status-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateComplaintStatusDialogComponent implements OnInit, AfterViewInit {

  readonly dialogRef = inject(MatDialogRef<UpdateComplaintStatusDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly title = model(this.data.title);
  readonly jobCardData = model(this.data.jobCardData);
  readonly status = model(this.data.status);
  readonly event = model(this.data.jobCardData); // Only valid at class member level

  userComments: string = '';
  additionalComments: string = '';
  otp: string = '';
  isAdmin: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private authContext: AuthContext
  ) {
  }

  ngOnInit(): void {
    const userInfo = this.authContext.getUserInfo();
    if(!userInfo.zoneIds.includes(1)) {
      this.isAdmin = true;
      this.otp = this.data.jobCardData.idRef;
    } else {
      if (userInfo.userType !== 'ROLE_JE') {
        this.isAdmin = true;
        this.otp = this.data.jobCardData.idRef;
      }
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  onBackClick(): void {
    this.dialogRef.close(
      { 
        okay: false, 
        jobCardData: this.data.jobCardData,
        userComments: null,
        additionalComments: null,
        status: null
      }
    );
  }

  onOkay() {
    if (this.data.status === 'CLOSED') {
      if (this.otp === this.data.jobCardData.idRef) {
        this.dialogRef.close(
          { 
            okay: true, 
            jobCardData: this.data.jobCardData,
            userComments: this.userComments,
            additionalComments: this.additionalComments,
            status: this.data.status
          }
        );
      } else {
        this.dialogRef.close(
          { 
            okay: false, 
            jobCardData: this.data.jobCardData,
            userComments: this.userComments,
            additionalComments: this.additionalComments,
            status: this.data.status
          }
        );
      }
    } else {
      this.dialogRef.close(
        { 
          okay: true, 
          jobCardData: this.data.jobCardData,
          userComments: this.userComments,
          additionalComments: this.additionalComments,
          status: this.data.status
        }
      );
    }
  }

}
